const menus = [
  /*  {
        id: 1,
        tomenu: "#about",
        namemenu: "About"
    },
    {
        id: 2,
        tomenu: "#chapters",
        namemenu: "chapters"
    },*/
    {
        id: 3,
        tomenu: "#testimonial",
        namemenu: "testimonial"
    },

    /*{{
        id: 4,
        tomenu: "#author",
        namemenu: "author"
    },

        id: 5,
        tomenu: "#pricing",
        namemenu: "pricing"
    },*/
    {
        id: 6,
        tomenu: "#contact",
        namemenu: "Contact"
    },
    {
        id: 7,
        tomenu: "#pricing",
        namemenu: "sign In",
    },
];



export default menus ;